var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4125 3.09561C14.3355 2.91781 14.208 2.76655 14.0458 2.66064C13.8835 2.55474 13.6937 2.49887 13.5 2.49999H2.49998C2.30644 2.50037 2.11717 2.5569 1.95512 2.66274C1.79308 2.76858 1.66523 2.91916 1.58709 3.09623C1.50894 3.27329 1.48386 3.46923 1.51488 3.66027C1.54591 3.85131 1.6317 4.02925 1.76186 4.17249L1.76686 4.17811L5.99998 8.69811V13.5C5.99994 13.681 6.04902 13.8586 6.14198 14.0139C6.23494 14.1692 6.36831 14.2963 6.52785 14.3817C6.68739 14.4672 6.86714 14.5077 7.04792 14.4991C7.22869 14.4904 7.40373 14.4328 7.55436 14.3325L9.55436 12.9987C9.69146 12.9074 9.80388 12.7836 9.88162 12.6384C9.95936 12.4932 10 12.331 9.99998 12.1662V8.69811L14.2337 4.17811L14.2387 4.17249C14.3703 4.0299 14.4569 3.85173 14.4878 3.66022C14.5187 3.4687 14.4925 3.27233 14.4125 3.09561ZM9.13623 8.16124C9.04974 8.25294 9.00107 8.37393 8.99998 8.49999V12.1662L6.99998 13.5V8.49999C7.00002 8.37302 6.95176 8.2508 6.86498 8.15811L2.49998 3.49999H13.5L9.13623 8.16124Z",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.1a47d616db20c10a79ef7000ab7831a7.svg";
export { ForwardRef as ReactComponent };